export default __webpack_public_path__ + "static/media/TG.9d3ea4cc.svg";